module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/task-dac0bae9ddb8c1c2161bb0d48da272d9.png";